import React from 'react'
import './style.min.css'

const RoundedTabs = ({ number, active, handleCurrentTech }) => {
  const {dotsArray} = initialiser(number, active, handleCurrentTech)
  console.log('TABS')

  return (
  <>
    <div className="TabContainer">
      {
        dotsArray.map(dot => 
          dot
        )
      }
    </div>
  </>
)}

const initialiser = (number, active, handleCurrentTech) => {
  // This get's the number and creates dot elements depending on the number
  const initialNO = parseInt(number)
  let dynamicNO = 1
  const activeDot = parseInt(active)
  let isActive // For adding active class on dots
  const dotsArray = []

  while (dynamicNO <= initialNO) {
    // Check if activeDot number === dynamicNO, if so then add active class to the element
    activeDot === dynamicNO ? isActive = true : isActive = false
    // console.log(dynamicNO, isActive)
    const el = <div
      className={`Dot ${isActive} xlarge`}
      key={dynamicNO*10}
      onClick={handleCurrentTech.bind(null, dynamicNO)}
    >
      {dynamicNO}
    </div>;
    dotsArray.push(el)
    dynamicNO++
  }

  return {
    dotsArray
  }
}

export default RoundedTabs